module.exports = __webpack_public_path__ + "static/media/MG.9ff47dbd.png";